export const optionsIndexer = [
	{ name: 'CDI', value: 'CDI' },
	{ name: 'TR', value: 'TR' },
	{ name: 'IPCA', value: 'IPCA' },
	{ name: 'IGPM', value: 'IGPM' }
];